import type { OperatorRole } from '@/types/api'
import type { AuditEntry, AuditRecordWire } from '@/types/audit-log'

// The audit handler speaks snake_case and omits empty fields; the UI reads camelCase with explicit
// nulls (BLO-948).
export function mapAuditEntry(wire: AuditRecordWire): AuditEntry {
    return {
        id: wire.id,
        occurredAt: wire.occurred_at,
        actorAddress: wire.actor_address ?? null,
        actorUserId: wire.actor_user_id ?? null,
        actorRoles: (wire.actor_roles ?? []) as OperatorRole[],
        action: wire.action,
        subjectType: wire.subject_type,
        subjectId: wire.subject_id,
        reason: wire.reason || null,
        before: wire.before ?? null,
        after: wire.after ?? null,
        requestId: wire.request_id || null,
        ip: wire.ip || null,
        userAgent: wire.user_agent || null,
    }
}
